import { Button } from '../../components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../../components/ui/dialog';
import type { CrmOnboardingRun } from '../../types/crmOnboarding';
import { confirmCopy } from '../../lib/crmOnboarding/confirmCopy';

// The explicit second phase of registering clubs. It names what is about to
// happen — the groups, the club count, how old the preview is — and says what
// the commit does and does not re-check. The wording lives in confirmCopy.ts so
// it is asserted without jsdom.

export function ConfirmRegistrationDialog({
  preview,
  open,
  pending,
  onCancel,
  onConfirm,
}: {
  preview: CrmOnboardingRun;
  open: boolean;
  pending: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}) {
  const r = preview.result;
  if (!r) return null;
  const copy = confirmCopy(r, preview.finishedAt ?? preview.startedAt, Date.now());
  return (
    <Dialog open={open} onOpenChange={(o) => (!o ? onCancel() : undefined)}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{copy.title}</DialogTitle>
          <DialogDescription>{copy.lead}</DialogDescription>
        </DialogHeader>
        <ul className="space-y-1 text-sm">
          {r.groupNames.map((g) => (
            <li key={g.id}>
              <span className="font-mono text-xs text-slate-500">group {g.id}</span>{' '}
              <span className="font-semibold">{g.name}</span>
            </li>
          ))}
        </ul>
        {copy.notes.map((n) => (
          <p key={n} className="text-sm text-slate-700">
            {n}
          </p>
        ))}
        <DialogFooter>
          <Button variant="outline" onClick={onCancel} disabled={pending}>
            Cancel
          </Button>
          <Button onClick={onConfirm} disabled={pending}>
            {pending ? 'Starting…' : copy.button}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
